import LiveDetailsPop from "./live-details";

export default LiveDetailsPop;